import { PUBLIC_LEADS_PATH } from '../../constants';

export default {
  ClassicIndiePop: `${PUBLIC_LEADS_PATH}/classic-indie-pop.mid`,
  GirlFutureLead: `${PUBLIC_LEADS_PATH}/girl-future-lead.mid`,
  GirlFutureLow: `${PUBLIC_LEADS_PATH}/girl-future-low.mid`,
  LeadOutOfFoals: `${PUBLIC_LEADS_PATH}/lead-out-of-foals.mid`,
  MoInspiredLead: `${PUBLIC_LEADS_PATH}/mo-inspired-lead.mid`,
  SomeKindOfMagic: `${PUBLIC_LEADS_PATH}/some-kind-of-magic.mid`,
  EaseLead: `${PUBLIC_LEADS_PATH}/ease-lead.mid`,
  EaseLeadLow: `${PUBLIC_LEADS_PATH}/ease-lead-low.mid`,
  NotLoveSong: `${PUBLIC_LEADS_PATH}/not-love-song.mid`,
  LoveLow: `${PUBLIC_LEADS_PATH}/lovelow.mid`,
  FractalArp: `${PUBLIC_LEADS_PATH}/fractalArp.mid`,
  SimpPen: `${PUBLIC_LEADS_PATH}/simp-pen.mid`,
  SimpPenLow: `${PUBLIC_LEADS_PATH}/simp-pen-low.mid`,
  TooBad: `${PUBLIC_LEADS_PATH}/toobad.mid`,
  TooBadLow: `${PUBLIC_LEADS_PATH}/toobadlow.mid`,
};
